import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../../Field'
import { FormikField } from '../../../../../Formik'
import { InputField } from '../../../../../Input'
import {
  REGISTRATION_FORM_FIELD_HEIGHT,
  REGISTRATION_FORM_FIELD_NAME_LAST_NAME,
  REGISTRATION_FORM_LAST_NAME_MAX_LENGTH,
} from '../../RegistrationForm.constants'

function LastNameField({ disabled }) {
  const { t } = useTranslation()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      Field={FieldStackedLabel}
      disabled={disabled}
      height={REGISTRATION_FORM_FIELD_HEIGHT}
      label={t('Auth.SignUpLastNameLabelKey')}
      maxLength={REGISTRATION_FORM_LAST_NAME_MAX_LENGTH}
      name={REGISTRATION_FORM_FIELD_NAME_LAST_NAME}
      placeholder={t('Auth.SignUpLastNamePlaceholderKey')}
    />
  )
}

export default LastNameField
